import { useContext } from 'react';
import {CompareGridContextProps } from "../../types"
import { CompareGridContext } from "../../context-manager"
import LplGrid from "./lpl-grid";
import { DefaultGrid } from "./default-grid";
import { KhGrid } from "./kh_grid";
import { KhCompareChart } from "./kh_compareChart";

// This is a Grid for AC Protection marketing campaign. 
const CompareGrid = () => {
    const { isLplPage, isKhPage } = useContext(CompareGridContext) as CompareGridContextProps

    const getContent =() =>{
        if (isLplPage) {
            return <LplGrid />
        } else if (isKhPage) {
            return <KhCompareChart />
        } else {
            return <KhCompareChart />
        }
    }    
    return (
        getContent()
    )
}
export default CompareGrid;